import { IVec3, Vec3 } from "@base/math/Vec3";
import { ConfiguratorItemData, IVariantData3d } from "@biz/definitions/IVariantData3d";
import { VariantData3d } from "@biz/definitions/VariantData3d";
import { CloneHelper } from "@biz/items/CloneHelper";
import { getBizImpl } from "@biz/items/product/BizImpls";
import { GroupHelper } from "@biz/logic/GroupHelper";

export class Variant3dClone {

  static #calcCloneOffset(old: IVariantData3d, id: string): IVec3 {
    const item = VariantData3d.findVariantData3dItem(old, id);
    if (item) {
      if (item?.itemType === "group") {
        const childIds = GroupHelper.calcRecursiveChildIds(old, id);
        let maxVec = Vec3.from(2, 0, 0);
        let maxLen = Vec3.len(maxVec);
        for (const childId of childIds) {
          const v = Variant3dClone.#calcCloneOffset(old, childId);
          const l = Vec3.len(v);
          if (l > maxLen) {
            maxLen = l;
            maxVec = v;
          }
        }
        return maxVec;
      }
      const cloned = getBizImpl(item.itemType).calcCloneOffset(item);
      if (cloned)
        return cloned;
    }

    return Vec3.from(5, 0, 0);
  }

  static cloneItem(old: IVariantData3d, id: string, options?: { newId?: string; parentId?: string; cloneOffset?: IVec3 }): { item: ConfiguratorItemData, children?: ConfiguratorItemData[] } | undefined {
    const item = VariantData3d.findVariantData3dItem(old, id);
    if (!item)
      return undefined;

    const cloneOffset = options?.cloneOffset || Variant3dClone.#calcCloneOffset(old, id);

    if (item.itemType === "group") {
      const clonedGroup = CloneHelper.clone(item, { children: [] }, options)
      if (clonedGroup) {
        const directChildren: ConfiguratorItemData[] = [];
        const indirectChildren: ConfiguratorItemData[] = [];
        for (const child of item.children) {
          const clonedChild = Variant3dClone.cloneItem(old, child, { parentId: clonedGroup.item.id, cloneOffset });
          if (clonedChild) {
            directChildren.push(clonedChild.item);
            if (clonedChild.children)
              indirectChildren.push(...clonedChild.children);
          }
        }
        clonedGroup.item.children = directChildren.map((c) => c.id)
        clonedGroup.children = [...(clonedGroup.children || []), ...directChildren, ...indirectChildren]
      }

      return clonedGroup;
    }

    const cloned = getBizImpl(item.itemType).cloneItem(item, options);
    if (cloned)
      return cloned;

    return undefined;
  }
}